import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import swal from 'sweetalert2';
import Navbar from '../components/navbar';
import Dashboard from '../components/dashboard';
import TPA from '../components/tpa';
import Doctor from '../components/doctor';
import Employee from '../components/employee';
import { getTPAList } from '../components/api/tpaAPI';
import MIS from '../components/mis';


const Master = (props) => {

    const [tpaList,             setTpaList]             = useState([]);

    const [tpa,                 setTPA]                 = useState(0);
    const [type,                setType]                = useState('All');
    const [status,              setStatus]              = useState('All');

    useEffect(() => {
        fetchTPAList();    
    }, [])


    const fetchTPAList = async() => {
        try {
            const { TPAList } = await getTPAList();
            setTpaList(TPAList);
        } catch (err) {
            swal.fire({ icon: "error", titleText: "Error!", text: err.message });
            return;  
        }
    }
    
    return (  
        <>                    
            <Navbar 
                tpaList={tpaList}
                tpa={tpa}
                setTPA={setTPA} 
                type={type} 
                setType={setType} 
                status={status} 
                setStatus={setStatus} 
            />
            <Switch>
                <Route path="/dashboard">
                    <Dashboard 
                        tpaList={tpaList}
                        tpa={tpa}
                        setTPA={setTPA}
                        type={type} 
                        setType={setType} 
                        status={status} 
                        setStatus={setStatus} 
                    />
                </Route>
                <Route path="/tpa">
                    <TPA />
                </Route>
                <Route path="/doctors">
                    <Doctor />
                </Route>
                <Route path="/employees">
                    <Employee />
                </Route>
                <Route path="/mis">
                    <MIS
                        tpaList={tpaList} 
                    />
                </Route>
                <Redirect to="/dashboard" />
            </Switch>
        </>
    )
}

export default withRouter(Master);